import ChartGenerator from "./ChartGenerator";
import NumberFormatter from "../number_formatter";
import _ from "underscore";
import {escapeHtmlSymbols} from "../atUtils";
import UserTime from "../user_time";
import AmCharts from "../alias/amcharts";

export default class PieChartGenerator extends ChartGenerator {

    _getDataProvider(chartData, config) {
        // abstract
    }

    _prepareChartSettings(chartData, config) {
        const labelFunction = this._createLabelFunction();
        const balloonFunction = this._createBalloonFunction();

        const dataProvider = this._getDataProvider(chartData, config);

        return {
            "type": "pie",
            "autoResize": false,
            "radius": 104,
            "innerRadius": 40,
            "outlineThickness": 1,
            "outlineAlpha": 1,
            "theme": "light",
            "addClassNames": true,

            "fontSize": 11,
            "labelRadius": 20,
            "maxLabelWidth": 300,
            "hideLabelsPercent": 1.5,
            "labelFunction": labelFunction,

            "autoMargins": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "startRadius": 100,
            "sequencedAnimation": false,

            "balloon": {
                "maxWidth": 350 // text width limited by balloon inner content
            },
            "balloonFunction": balloonFunction,

            "titleField": "category",
            "valueField": "value",
            "colorField": "sectorColor",
            "dataProvider": dataProvider
        };
    }

    updateSettingsForExport(settings, chartData, config) {
        const scales = this._getChartScales(config);
        settings["fontSize"] *= scales.common;
        settings["outlineThickness"] *= scales.common;
        settings["maxLabelWidth"] *= scales.horizontal;
        settings["radius"] *= scales.common;
        settings["innerRadius"] *= scales.common;
    }

    _createLabelFunction() {
        return function(slice)
        {
            return slice.dataContext.category.substring(0, 65);
        }
    }

    _createBalloonFunction() {
        const numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true);
        const balloonTemplate = _.template("<div class='cpChartsBalloon'>" +
                                           "   <span class='category'><%=category%></span>" +
                                           "   <div class='values'><span class='value'><%=value%></span> <span>(<%=percents%>%)</span></div>" +
                                           "</div>");
        return function(item)
        {
            return balloonTemplate({
                "category": escapeHtmlSymbols(item.dataContext.category),
                "value": UserTime.formatTime(item.dataContext.value),
                "percents": numberFormatter.format(item.percents)
            });
        }
    }

    makeChart(container, settings) {
        this._chart = AmCharts.makeChart(container, settings, 10);
    }

    resizePieChart(marginTop, marginBottom) {
        this._chart.marginTop = marginTop;
        this._chart.marginBottom = marginBottom;
        this._redrawChart();
    }

    rescalePieChartForExport(marginTop, marginBottom, chartSize) {
        const scale = (chartSize["height"] - marginTop - marginBottom) / chartSize["height"];
        this._chart.radius *= scale;
        this._chart.innerRadius *= scale;
        this._chart.fontSize *= scale;
        this._chart.outlineThickness *= scale;
        this._redrawChart();
    }

    _redrawChart() {
        this._chart.validateNow(); // redraw chart and force 'onRendered' event
    }

    removeReferenceOnChart() {
        this._chart = null;
    }
}


// WEBPACK FOOTER //
// ./web/js/chart/PieChartGenerator.js